module.exports = __webpack_public_path__ + "img/trash.f93b646f.svg";